import './index_mWeb.css';
import React from 'react';
import useTheme from '../../utilities/hooks/theme';
import { getRealBalanceObj, isMatchInScheduled } from '../../utilities/helper';
import CountdownTimer from '../countdown_timer';
import View from '../view';
import Text from '../text';
import Constants from '../../constants';
import { useSelector } from 'react-redux';

interface CounterWrapperProps {
  matchItem?: any;
  isMatchScheduled?: boolean;
  onCalledDeadline: any;
  verified?: boolean;
  matchStatus?: number;
  gameType?: string;
}

const CounterWrapper = ({
  matchItem,
  isMatchScheduled,
  onCalledDeadline,
  verified,
  matchStatus,
  gameType
}: CounterWrapperProps) => {
  const { ComponentTheme } = useTheme();
  const timeStyle = {
    color: ComponentTheme.headerTitle
  };
  return (
    <>
      {isMatchScheduled ? (
        <View className="header-with-timer-counter-wrapper__mWeb">
          <CountdownTimer
            style={{
              fontFamily: 'ProximaNova-SemiBold',
              fontSize: '1.1rem',
              paddingRight: '8px',
              color: ComponentTheme.headerTitle,
              marginBottom: 0,
              textAlign: 'center',
              opacity: 0.8
            }}
            onCalledDeadline={onCalledDeadline}
            isShowAlert={true}
            matchItem={matchItem}
            gameType={gameType}
          />
        </View>
      ) : matchStatus === 2 && !verified ? (
        <View className="header-with-timer-counter-wrapper__mWeb">
          <Text className="header-with-timer-counter-timer__mWeb" style={timeStyle}>
            {'(Reviewed)'}
          </Text>
        </View>
      ) : matchStatus === 2 ? (
        <View className="header-with-timer-counter-wrapper__mWeb">
          <Text className="header-with-timer-counter-timer__mWeb" style={timeStyle}>
            {'(Completed)'}
          </Text>
        </View>
      ) : matchStatus === 3 ? (
        <View className="header-with-timer-counter-wrapper__mWeb">
          <Text className="header-with-timer-counter-timer__mWeb" style={timeStyle}>
            {'(Live)'}
          </Text>
        </View>
      ) : (
        <View className="header-with-timer-counter-wrapper__mWeb">
          <Text className="header-with-timer-counter-timer__mWeb" style={timeStyle}>
            {'(Abandoned)'}
          </Text>
        </View>
      )}
    </>
  );
};

interface Props {
  matchItem?: any;
  onPressBack?: React.MouseEventHandler;
  onlyTimer?: boolean;
  tabType?: string;
  onCalledDeadline?: any;
  onlyTitle?: any;
  screen?: string;
  teamName?: string;
  gameType?: string;
  isCreateTeam?: boolean;
}
const HeaderWithTimerMWeb = ({
  matchItem,
  onPressBack,
  onlyTimer = false,
  onlyTitle = false,
  onCalledDeadline,
  teamName = '',
  gameType,
  isCreateTeam = true
}: Props) => {
  const { ComponentTheme, DashboardTheme: theme } = useTheme();
  const { xpPoints = 0, balanceInfo } = useSelector((state: any) => state.user);
  const balance = getRealBalanceObj(balanceInfo);

  const {
    teamA = {},
    teamB = {},
    status: matchStatus,
    verified,
    gameState = 0,
    matchDelayed = false
  } = matchItem;

  const matchTitleTextColor = {
    color: ComponentTheme.headerTitle
  };

  const isMatchScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });

  const xpCoinContainerStyle = {
    background: theme.dashBoardHeaderXpCoinContainerBg
  };
  // const timerIconDimension = '15px';
  return (
    <View
      className="header-with-timer-container__mWeb"
      style={{
        backgroundColor: '#11171d'
      }}>
      <View onPress={onPressBack} className="header-with-timer-back-btn-wrapper__mWeb">
        <Constants.Svgs.Back />
      </View>
      <View className="header-with-timer-left-wrapper__mWeb">
        {!onlyTimer && (
          <Text style={matchTitleTextColor} className="header-with-timer-title__mWeb">
            {`${teamA?.shortName} vs  ${teamB?.shortName}`}
          </Text>
        )}
        {isCreateTeam && teamName && (
          <Text style={matchTitleTextColor} className="header-with-timer-team-title__mWeb">
            {`${teamName}`}
          </Text>
        )}
        <View className="header-with-timer-wrapper__mWeb">
          {/* {isMatchScheduled && !onlyTitle && (
            <View className="header-with-timer-icon-wrapper">
              <Constants.Svgs.Timer width={timerIconDimension} height={timerIconDimension} />
            </View>
          )} */}
          {!onlyTitle && (
            <CounterWrapper
              onCalledDeadline={onCalledDeadline}
              matchStatus={matchStatus}
              verified={verified}
              matchItem={matchItem}
              isMatchScheduled={isMatchScheduled}
              gameType={gameType}
            />
          )}
        </View>
      </View>
      {teamName && (
        <React.Fragment>
          <div className="header__coin__container__mWeb" style={xpCoinContainerStyle}>
            <img src={Constants.Images.xp} width={30} />
            <Text className="header__xp__coins__txt">{xpPoints}</Text>
          </div>
          <div className="header__xp__container__mWeb" style={xpCoinContainerStyle}>
            <img className="header__Coins__img__mWeb" src={Constants.Images.coin} />
            <Text className="header__xp__coins__txt__mWeb">{balance['totalBalance']}</Text>
            <img
              className="header__addCashPlus__img__mWeb"
              src={Constants.Images.addCashPlus}
              width={'15px'}
            />
          </div>
        </React.Fragment>
      )}
    </View>
  );
};
export default React.memo(HeaderWithTimerMWeb);
